import { sprintf } from 'sprintf-js';
const _ = importLib('lodash');
const M = importLib('moment');
const Vuex = importLib('vuex');
const getHelpers = importLib('getHelpers');

const api = getHelpers('api');
const getImagePath = getHelpers('getImagePath');
const getImagePathBasic = getHelpers('getImagePathBasic');
const getAssetPath = getHelpers('getAssetPath');
const getVideoPath = getHelpers('getVideoPath');
const formatString = getHelpers('formatString');
const isNotNullUndefined = getHelpers('isNotNullUndefined');
_.mixin({
    imgPath: getImagePath,
    imgPathBasic: getImagePathBasic,
    filePath: getAssetPath,
    videoPath: getVideoPath,
    str: formatString,
    isNotNullUndefined: isNotNullUndefined,
});

export default {
    computed: {
        ...Vuex.mapGetters({
            customer: 'customer',
        }),

        loggedIn() {
            return _.get(this.customer, 'attributes.registered');
        },

        _() {
            return _;
        },

        api() {
            return api;
        },

    },

    methods: {
        __(value, format = null) {
            return formatString(value, format);
        },

        randomKey() {
            return Math.floor(Math.random() * 1000000);
        },

        serialize(value) {
            return JSON.stringify(value);
        },

        isElementInViewport(el) {
            var rect = el.getBoundingClientRect();

            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
                rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
            );
        },

        scrollTo(className, offset = 70) {

            if (window.innerWidth >= 992) {
                offset = 140;
            } else {
                offset = 70;
            }

            let firstError =  $('.' + className + ':visible:first');
            if (firstError.length) {
                $('html, body').animate({
                    scrollTop: $('.' + className + ':visible:first').offset().top - offset
                }, 500);
            }
        },

        getUnix(ts) {
            return moment(ts).unix();
        },
    }
}
